<template>
  <div
    :class="{
      'map-positions-card-inner': true,
      active: homePosition ? homePosition.id == position.id : false
    }"
    :style="{ 'background-color': appAsset ? appAsset.color_primary : null }"
    @click="setHomePosition()"
  >
    <div
      class="map-positions-card-inner__address"
      :style="{ color: appAsset ? appAsset.color_primary : null }"
    >
      {{ position.address }}
    </div>
    <div
      class="map-positions-card-inner__name"
      :style="{ color: appAsset ? appAsset.color_primary : null }"
    >
      {{ position.gemeente.name }}
    </div>
    <button
      class="map-positions-card-inner__button"
      @click="setActivePosition()"
    >
      <span class="map-positions-card-inner__button__left">
        <svg class="map-positions-card-inner__button__icon" svg-inline="" :style="{ fill: appAsset ? appAsset.color_primary : null }" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M19.778 2H4.21c-1.233 0-2.2.989-2.2 2.222L2 19.778C2 21 2.978 22 4.211 22h15.567C21 22 22 21 22 19.778V4.222C22 2.99 21 2 19.778 2zm0 13.333h-4.445c0 1.845-1.5 3.334-3.333 3.334a3.336 3.336 0 01-3.333-3.334H4.21V4.223h15.567v11.11z" fill="#101010" mask="url(#b)"/></g></svg>
        <span class="map-positions-card-inner__button__text"
          >Totaal
          {{ positionFeatures ? positionFeatures.length : 0 }} meldingen</span
        >
      </span>
      <span class="map-positions-card-inner__button__right">
        <span
          class="map-positions-card-inner__button__circle"
          :style="{
            'background-color': appAsset ? appAsset.color_primary : null
          }"
        >
          {{ positionFeaturesUnread ? positionFeaturesUnread : 0 }}</span
        >
      </span>
    </button>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";

export default {
  props: {
    position: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      positionFeatures: null,
      positionFeaturesUnread: null
    };
  },
  computed: {
    homePosition() {
      return this.$store.state.ui.homePosition;
    },
    appAsset() {
      return this.position.gemeente.app_asset;
    },
    updateFeatures() {
      return this.$store.state.ui.updateFeatures;
    },
    readFeatures() {
      return this.$store.state.ui.readFeatures;
    }
  },
  methods: {
    setActivePosition() {
      if (this.positionFeatures) {
        if (this.positionFeatures.length > 0) {
          this.$store.commit("setActivePosition", this.position);
          this.$store.commit("closeLayoutHome");
          this.$store.commit("openLayoutPosition");
          this.$store.commit("openSidebarPositionDetailIndex");
          this.$router.push(`/positions/${this.position.id}`);
        }
      }
    },
    setHomePosition() {
      this.$store.commit("setHomePosition", this.position);
    },
    getFeatures() {
      let self = this;

      PrivateApi()
        .get(`positions/${this.position.id}/features`)
        .then(function(features) {
          self.positionFeatures = features.data.features;

          let featureIds = features.data.features.map(x => x.properties.id);
          let readFeatures = self.readFeatures;
          let positionFeaturesUnread = 0;

          featureIds.forEach(function(featureId) {
            if (readFeatures.includes(featureId)) {
              positionFeaturesUnread++;
            }
          });

          self.positionFeaturesUnread =
            features.data.features.length - positionFeaturesUnread;
        });
    }
  },
  mounted() {
    this.getFeatures();
  },
  watch: {
    position: function() {
      this.getFeatures();
    },
    updateFeatures: function() {
      this.getFeatures();
    }
  }
};
</script>

<style scoped lang="scss">
.map-positions-card-inner {
  position: relative;
  padding: $spacing-3;
  background: $color-green-1;
  border-radius: 5px 5px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
  border-radius: 16px 16px 0 0;

  &:not(.active) {
    border-color: #efefef;
    background-color: #fff !important;
  }

  &__address {
    @extend %text-title-1;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__name {
    @extend %text-large;
  }

  &__button {
    display: flex;
    margin-top: auto;
    align-items: center;
    height: 56px;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.05);
    padding: 0 $spacing-3;

    &__left {
      display: flex;
      align-items: center;
    }

    &__icon {
      margin-right: $spacing-2;
    }

    &__text {
      @extend %text-small;
    }

    &__right {
      margin-left: auto;
    }

    &__circle {
      display: inline-block;
      width: 24px;
      height: 24px;
      border-radius: 100%;
      line-height: 24px;
      @extend %text-mini;
      background: $color-green-1;
      color: #fff;
    }
  }
}

.map-positions-card-inner.active {
  .map-positions-card-inner__address {
    color: #fff !important;
  }
  .map-positions-card-inner__name {
    color: #fff !important;
  }
}
</style>
